import { LOCIZE_NS } from '@avanta/shared/constants/common';
import { Tag, Tags } from 'lucide-react';
import { type ReactElement, type ReactNode } from 'react';
import { Trans } from 'react-i18next';
import { Link } from 'react-router';
import { ROUTES } from 'constants/routes';
import { type PaeHeroSessionsState, PAE_HERO_SESSIONS_STATE } from './types';
import { usePaeHeroSessionsModel } from './usePaeHeroSessionsModel';

const SESSION_ICON_CLASS = 'size-6 shrink-0 text-denim-500 am-3xl:size-8';
const SESSIONS_CTA_LINK_CLASS =
  'text-sm font-medium leading-4.5 text-teal-600 underline decoration-teal-600 underline-offset-2 transition-colors hover:text-teal-500 hover:no-underline';
const PaeHeroSessionsTransLink = ({ children }: { children?: ReactNode }): ReactElement => (
  <Link to={ROUTES.APPOINTMENTS} className={SESSIONS_CTA_LINK_CLASS}>
    {children}
  </Link>
);
const HERO_SESSIONS_TRANS_COMPONENTS = {
  bold: <span className="font-semibold text-denim-900" />,
  sessionsLink: <PaeHeroSessionsTransLink />,
};

const I18N_KEY_BY_STATE: Record<PaeHeroSessionsState, string> = {
  [PAE_HERO_SESSIONS_STATE.none]: 'Pae.PaeHero.sessions.stateNone',
  [PAE_HERO_SESSIONS_STATE.single]: 'Pae.PaeHero.sessions.stateSingle',
  [PAE_HERO_SESSIONS_STATE.multiple]: 'Pae.PaeHero.sessions.stateMultiple',
  [PAE_HERO_SESSIONS_STATE.unlimited]: 'Pae.PaeHero.sessions.stateUnlimited',
};

export const PaeHeroSessions = (): ReactElement => {
  const model = usePaeHeroSessionsModel();
  const Icon = model.state === PAE_HERO_SESSIONS_STATE.single ? Tag : Tags;
  const i18nKey = I18N_KEY_BY_STATE[model.state];

  return (
    <div className="grid w-full max-w-155 grid-cols-[auto_1fr] items-start gap-3">
      <Icon aria-hidden className={SESSION_ICON_CLASS} strokeWidth={1.5} />
      <p className="min-w-0 text-sm leading-5 text-denim-800 am-3xl:text-base">
        <Trans
          ns={LOCIZE_NS.HOME}
          i18nKey={i18nKey}
          values={
            model.state === PAE_HERO_SESSIONS_STATE.multiple
              ? { count: model.multipleCount }
              : undefined
          }
          components={HERO_SESSIONS_TRANS_COMPONENTS}
        />
      </p>
    </div>
  );
};
